import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Helmet } from 'react-helmet';
import SettingsPage from 'components/SettingsPage';
import QuickbooksCard from 'components/Preference/QuickbooksCard';

// Settings > Accounting setup (/preferences/accounting_setup).
@inject('userStore', 'taxStore', 'productServiceStore', 'paymentMethodStore') @observer
class AccountingSetup extends Component {

  componentDidMount() {
    const { userStore, taxStore, productServiceStore, paymentMethodStore } = this.props;
    userStore.loadQuickbooks();
    taxStore.loadTaxes();
    productServiceStore.loadProductsServices();
    paymentMethodStore.loadPaymentMethods();
  }

  render() {
    const { quickbooks } = this.props.userStore;
    const firstLoad = quickbooks.isLoading && !(quickbooks.data && quickbooks.data.company_name);
    return (
      <React.Fragment>
        <Helmet>
          <title>Accounting setup | FieldNexus</title>
        </Helmet>
        <SettingsPage
          title="Accounting setup"
          description="Connect QuickBooks and link your taxes, products and payment methods."
        >
          {firstLoad ? (
            <div className="sp-card sp-card--loading" role="status" aria-label="Loading accounting setup">
              <span className="dl-bone" style={{ width: 240, height: 18 }} />
              <span className="dl-bone" style={{ width: '100%', height: 56 }} />
              <span className="dl-bone" style={{ width: 180, height: 36 }} />
            </div>
          ) : (
            <QuickbooksCard />
          )}
        </SettingsPage>
      </React.Fragment>
    );
  }
}

export default AccountingSetup;
